import React from 'react';
import { Icon } from './Icon.js';
export const IconMediaSkipToStart = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M13 12L21 5V19L13 12Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M2.49998 12L10.5 5V19L2.49998 12Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconMediaSkipToStart.js.map